import { render } from "./ViewAnalyticsPerfection.vue?vue&type=template&id=bdc2b43a&scoped=true"
import script from "./ViewAnalyticsPerfection.vue?vue&type=script&lang=js"
export * from "./ViewAnalyticsPerfection.vue?vue&type=script&lang=js"

import "@/css/views/view-analytics-perfection.css?vue&type=style&index=0&id=bdc2b43a&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdc2b43a"]])

export default __exports__